import type { FC } from 'react';
import { useState } from 'react';
import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';

import { applyCypressData } from 'Utilities/helpers';

import texts from '../DownloadCSV.texts';

import { DownloadCSVPopoverContentRadioButton } from './DownloadCSVPopoverContentRadioButton/DownloadCSVPopoverContentRadioButton';
import type { DownloadCSVPopoverContentProps } from './DownloadCSVPopoverContent.types';

import styles from './DownloadCSVPopoverContent.module.scss';

const T = new MDText(texts);

export const DownloadCSVPopoverContent: FC<DownloadCSVPopoverContentProps> = ({
	cypressId,
	items,
	onDownloadClick,
	title,
}) => {
	const [selectedItemId, setSelectedItemId] = useState(items[0]?.id);

	return (
		<div className={styles.container}>
			<h6 className={styles.title}>{title}</h6>
			{items.length > 0 && (
				<div className={styles.items}>
					{items.map(({ cypressId: itemCypressId, id, label }) => (
						<DownloadCSVPopoverContentRadioButton
							key={id}
							cypressId={itemCypressId}
							id={id}
							label={label}
							onChange={setSelectedItemId}
							selectedItemId={selectedItemId}
						/>
					))}
				</div>
			)}
			<div className={styles.actions}>
				<Button
					aria-label={String(T.translate('popover.button.ariaLabel'))}
					className={styles.button}
					label={String(T.translate('popover.button.label'))}
					onClick={() => onDownloadClick(selectedItemId)}
					size="small"
					{...applyCypressData(cypressId)}
				/>
			</div>
		</div>
	);
};
